import React  from 'react'
import {Grid ,Container, Icon , GridRow, GridColumn , Menu, MenuItem ,Popup , Divider} from "semantic-ui-react";
import { Link } from 'react-router-dom';
//import useAuth from '../../hooks/useAuth';
import { useQuery } from '@apollo/client';
import { GETGLOBAL } from '../../../gql/global';
import Samples from '../../Bienvenida/Samples/Samples';

//import FeedVent from './FedExterior/FedExterior';
import Footer from '../Footer/Footer';
import FedExterior from './../FedExterior/FedExterior';
import FooterIn from "./FooterIn"


import "./Inicio.scss";



export default function Inicio() {

const { data, loading, error, refetch} = useQuery (GETGLOBAL,{
    variables: { id:"67355bb3437eedf7b8e59490" } ,
  });

  if (loading) return null ;
  const { getGlobal } = data; 
  /*const avis = () => {
    
     alert("no has iniciado sesion ")

};*/

console.log(data)

const reload = () => {
    

  window.location.reload()
};

  

  return (

 
<>





    <GridColumn className='homex' centered mobile ={16} computer= {1} >
    
       <div>

        <FedExterior getGlobal={getGlobal}/>
        </div>

      </GridColumn>
      <Divider/>

<GridRow>
  <Samples/>
</GridRow>



     
<div className='fett'>

<h4> Visitas  <h5> 👣   🐾  👣 </h5> </h4>

<h4>👁️ {getGlobal[0].countGlobal}</h4>
<h4> Powered by <h5> C W </h5> </h4>


</div>

<Container>

  <FooterIn/>
</Container>

     













 </>


  )


}
